module.exports = __webpack_public_path__ + "img/about-company-01.46a59dde.webp";